import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M11_TOPICS, M11_MODULE_INFO } from '../data/mathExercises/M11_Ratios';

// Create mock problems data for M11 
const M11_PROBLEMS_DATA = {
  'M11_01': [
    {
      id: 'M11_01_P001',
      topicId: 'M11_01',
      question: "將比 6:9 化為最簡比",
      solution: "2:3",
      explanation: "找出最大公因數並約分",
      difficulty: 1,
      order: 1,
      steps: ["找出 6 和 9 的最大公因數：3", "6÷3 = 2, 9÷3 = 3", "最簡比為 2:3"]
    },
    {
      id: 'M11_01_P002',
      topicId: 'M11_01',
      question: "在比例 a:b = 3:4 中，若 a = 15，求 b",
      solution: "b = 20",
      explanation: "利用比例的基本性質求解",
      difficulty: 1,
      order: 2,
      steps: ["設比例常數為 k", "a = 3k = 15，所以 k = 5", "b = 4k = 4×5 = 20"]
    }
  ],
  'M11_02': [
    {
      id: 'M11_02_P001',
      topicId: 'M11_02',
      question: "若 y 與 x 成正比例，且當 x = 4 時 y = 12，求比例常數",
      solution: "k = 3",
      explanation: "正比例關係 y = kx 中求比例常數",
      difficulty: 1,
      order: 1,
      steps: ["正比例：y = kx", "代入 x = 4, y = 12", "12 = k×4，所以 k = 3"]
    }
  ],
  'M11_03': [
    {
      id: 'M11_03_P001',
      topicId: 'M11_03',
      question: "若 y 與 x 成反比例，且當 x = 3 時 y = 8，當 x = 6 時求 y",
      solution: "y = 4",
      explanation: "反比例關係 xy = k 中求未知數",
      difficulty: 1,
      order: 1,
      steps: ["反比例：xy = k", "由 x = 3, y = 8 得 k = 24", "當 x = 6 時，6y = 24，所以 y = 4"]
    }
  ],
  'M11_04': [
    {
      id: 'M11_04_P001',
      topicId: 'M11_04',
      question: "若 z 與 x 成正比例，與 y 成反比例，且當 x = 2, y = 3 時 z = 8，求比例關係",
      solution: "z = 12x/y",
      explanation: "聯比例關係的建立",
      difficulty: 2,
      order: 1,
      steps: ["聯比例：z = kx/y", "代入 x = 2, y = 3, z = 8", "8 = k×2/3，所以 k = 12", "比例關係：z = 12x/y"]
    }
  ],
  'M11_05': [
    {
      id: 'M11_05_P001',
      topicId: 'M11_05',
      question: "彈簧的彈力與伸長量成正比例，已知伸長 2cm 時彈力為 10N，求彈簧常數",
      solution: "k = 5 N/cm",
      explanation: "物理中的正比例關係應用",
      difficulty: 2,
      order: 1,
      steps: ["胡克定律：F = kx", "代入 F = 10N, x = 2cm", "10 = k×2，所以 k = 5 N/cm"]
    }
  ],
  'M11_06': [
    {
      id: 'M11_06_P001',
      topicId: 'M11_06',
      question: "某商品打 8 折後售價為 240 元，求原價",
      solution: "原價 300 元",
      explanation: "百分比與比率的應用",
      difficulty: 1,
      order: 1,
      steps: ["8 折即 80% = 0.8", "設原價為 x 元", "0.8x = 240，所以 x = 300"]
    }
  ]
};

const M11RatiosExercise = ({ onProgress }) => {
  // Convert problemsData to flat problems array
  const problems = Object.values(M11_PROBLEMS_DATA).flat();
  
  return (
    <ExerciseInterface
      moduleInfo={M11_MODULE_INFO}
      topics={M11_TOPICS}
      problems={problems}
      onProgress={onProgress}
      className="m11-exercise"
    />
  );
};

export default M11RatiosExercise; 